module.exports = __webpack_public_path__ + "img/calendar_icon.be5e9876.svg";